var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"notification d-flex align-items-center",attrs:{"show":!_vm.production && (_vm.manual || _vm.countDown),"dismissible":"","fade":"","variant":_vm.variant},on:{"dismissed":_vm.clear}},[_c('p',{staticClass:"mb-0 ml-2"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }